(() => {
  let queued = false, frame = null;
  const observer = new MutationObserver(() => {
    if (!queued) { queued = true; frame = requestAnimationFrame(update); }
  });
  function sync(form, checked) {
    form.querySelectorAll('.restock-rocket-acknowledgement-checkbox input[type="checkbox"]').forEach(input => {
      if (input.checked !== checked) {
        input.checked = checked;
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }
    });
  }
  function update() {
    queued = false;
    observer.disconnect();
    document.querySelectorAll('product-form').forEach(form => {
      const notice = form.querySelector('.supplier-notice');
      if (!notice) return;
      form.dataset.supplierMode = 'notice';
      const ack = notice.querySelector('input[type="checkbox"]');
      const variant = form.querySelector('[name="id"]')?.value;
      if (form.dataset.supplierVariant && form.dataset.supplierVariant !== variant && ack) ack.checked = false;
      form.dataset.supplierVariant = variant || '';
      sync(form, ack ? ack.checked : true);
      form.querySelectorAll('.restock-rocket-preorder-button').forEach(button => {
        const span = button.querySelector('span');
        if (span && span.textContent !== 'Add to Cart') span.textContent = 'Add to Cart';
      });
    });
    observer.observe(document.body, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['value']});
  }
  function guard(event) {
    const pending = document.querySelector('[data-supplier-cart-pending="true"]');
    if (pending && (event.type==='submit' && event.target.id==='cart' || event.type==='click' && event.target.closest('[name="checkout"], a[href*="/checkout"]'))) {
      event.preventDefault(); event.stopImmediatePropagation();
      document.querySelector('[data-supplier-cart-line] input[type="checkbox"]')?.focus();
      return;
    }
    const form = event.target.closest('product-form[data-supplier-mode="notice"]');
    if (!form) return;
    const ack = form.querySelector('.supplier-notice input[type="checkbox"]');
    if (!ack || ack.checked) return;
    if (event.type === 'click' && !event.target.closest('button[type="submit"], .restock-rocket-preorder-button, .shopify-payment-button, a[href*="checkout"]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    ack.reportValidity(); ack.focus();
  }
  document.addEventListener('click', guard, true);
  document.addEventListener('submit', guard, true);
  document.addEventListener('change', event => {
    if (!event.target.matches('.supplier-notice input[type="checkbox"]')) return;
    const form = event.target.closest('product-form');
    if (form) sync(form, event.target.checked);
    const line = event.target.closest('[data-supplier-cart-line]');
    if (line && event.target.checked) {
      event.stopImmediatePropagation();
      const input = event.target; input.disabled = true;
      const original = JSON.parse(line.dataset.supplierProperties || '{}') || {};
      const properties = Array.isArray(original) ? Object.fromEntries(original) : {...original};
      properties['Import notice acknowledged'] = input.value;
      fetch(window.Shopify.routes.root + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.dataset.supplierCartLine,quantity:Number(line.dataset.supplierQuantity),properties})})
        .then(response => { if (!response.ok) throw Error('Could not save acknowledgement'); return response.json(); })
        .then(cart => {if(!cart.items.some(item => item.properties?.['Import notice acknowledged']===input.value))throw Error('Acknowledgement was not saved'); window.location.reload();})
        .catch(() => {input.disabled=false;input.checked=false;line.querySelector('[role="status"]').textContent='Could not save acknowledgement. Please try again before checkout.';});
    }
  }, true);
  window.addEventListener('pagehide', () => { observer.disconnect(); if (frame !== null) cancelAnimationFrame(frame); });
  update();
})();
